// extracted by mini-css-extract-plugin
export default {"header":"Production_header__Sadcy","title":"Production_title__Fqhx1","chart":"Production_chart__-DZBG","noData":"Production_noData__HfHno"};